// should this be moved to fe-design-system as an option on Text?

import { Children } from 'react';
import type { ElementType } from 'react';

import { Text } from '@change/ds-core-ui';
import type { TextProps } from '@change/ds-core-ui';

import type { PropsWithSyncChildren, SyncReactNode } from '#src/app/shared/types';

// Mirror the polymorphic call-signature pattern used by @change/ds-core-ui's Text component
// so that `as="div"` (and other element overrides) are accepted with correct prop types.
type TextNl2BrType = <T extends ElementType = 'span'>(props: PropsWithSyncChildren<TextProps<T>>) => React.ReactNode;

export const TextNl2Br: TextNl2BrType = ({ children, ...rest }) => {
	const childrenAsArray = Children.toArray(children);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return <Text {...(rest as any)}>{childrenAsArray.map((child) => nl2br(child as SyncReactNode))}</Text>;
};

const NEWLINE_REGEX = /(\r\n|\r|\n)/g;

function nl2br(str: SyncReactNode) {
	if (typeof str !== 'string') {
		return str;
	}

	return str.split(NEWLINE_REGEX).map((line, index) => {
		if (line.match(NEWLINE_REGEX)) {
			// eslint-disable-next-line react/no-array-index-key
			return <br key={index} />;
		}
		return line;
	});
}
